// utility
// remove line breaks, trailing whitespace, enter key characters and non breaking hyphens (which are not in the font set).
export const cleanText = (text) => {
	if (typeof text !== "undefined") {
		let cleanText = text
			.replace(/(\r\n|\n|\r)/gm, "")
			.replace("↵", "")
			.replace(/\u21b5/g, "")
			.replace(/\u2011/g, "-")
			.replace(/\s\s+/g, " ");
		return cleanText;
	}
	return false;
};

export const toTitleCase = (str) => {
	return str.replace(/\w\S*/g, function (txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	});
};

// get query string params
export const getUrlParams = (str) => {
	return new URL(str).searchParams;
};

// main styling
// elements will loop through this until they reach a #text node type
export const styleElement = (paragraph, style, hideSup, isLegacyDisclosures, stripAnchorTags) => {
	let childCount = 0,
		content = [],
		isRisk = false,
		isLineBreak = false;

	if (
		typeof paragraph !== "undefined" &&
		paragraph !== null &&
		paragraph.nodeName !== "SVG" &&
		paragraph.nodeName !== "SCRIPT"
	) {
		if (paragraph.childNodes) {
			childCount = paragraph.childNodes.length;
		}

		if (paragraph.nodeName !== "#text") {
			if (paragraph.closest(".risk-disclosure") !== null) {
				style = "disclosure-footer-risk";
			}
		}

		// special formatting elements (line break)
		if (typeof paragraph.classList !== "undefined" && paragraph.nodeName === "SPAN") {
			if (paragraph.classList.contains("pdf--line-break")) {
				isLineBreak = true;
				content.push({
					text: "\n"
				});
			}
		}

		// plain text
		if (paragraph.nodeName === "#text") {
			let cleanedText = cleanText(paragraph.textContent);
			const pNode = paragraph.parentNode;

			if (
				typeof isLegacyDisclosures === "undefined" ||
				isLegacyDisclosures === true ||
				isLegacyDisclosures === null
			) {
				// if last element in parent add spacing
				if (
					(pNode.nodeName === "P" || pNode.nodeName === "SPAN" || isRisk) &&
					paragraph.nextSibling === null
				) {
					cleanedText = cleanedText + "\n\n";
				}
			} else if (
				typeof isLegacyDisclosures !== "undefined" ||
				isLegacyDisclosures === false ||
				isLegacyDisclosures !== null
			) {
				// add only single newline for exhibit disclosures / non-legacy
				if (pNode.nodeName === "P" || pNode.nodeName === "SPAN" || isRisk) {
					cleanedText = cleanedText + "\n";
				}
			}

			if (cleanedText !== "" && cleanedText !== " ") {
				content.push({
					text: cleanedText,
					style: style
				});
			}
		} else if (paragraph.nodeName === "BR") {
			content.push({
				text: "\n"
			});
		} else if (paragraph.nodeName === "A") {
			let linkText = cleanText(paragraph.innerText);
			if (paragraph.nextSibling === null) {
				linkText = linkText + "\n\n";
			}
			// add risk disclosure styling to links except in teal color
			if (paragraph.closest(".risk-disclosure") !== null) {
				style = "disclosure-risk-link";
			}
			let linkHref = paragraph.href.includes("pause?")
				? getUrlParams(paragraph.href).get("r")
				: paragraph.href;
			let linkStyle =
				style === "disclosure-risk-link"
					? "disclosure-risk-link"
					: style === "exhibit-disclosure"
						? "exhibit-disclosure-link"
						: style === "footNote"
							? "footnoteLink"
							: style === "disclosure"
								? "disclosureLink"
								: style === "appendix"
									? "appendixLink"
									: "link";

			if (stripAnchorTags === true) {
				content.push({
					text: linkText,
					style: style
				});
			} else {
				content.push({
					text: linkText,
					link: linkHref,
					style: linkStyle
				});
			}
		} else if (paragraph.nodeName === "SUP" && !hideSup) {
			let supText = cleanText(paragraph.innerText) + " ";
			let supStyle = { style: "sup" };

			// if sup is the last element in its parent
			if (paragraph.nextSibling === null) {
				supText = supText + "\n\n";
			}

			// if sup is part of an equation, style differently
			if (paragraph.previousElementSibling !== null) {
				if (paragraph.previousElementSibling.nodeName === "EM") {
					supText = " " + supText;
					supStyle = { sup: { sup: true }, fontSize: 5 };
				}
			}

			content.push({
				text: supText,
				...supStyle
			});
		} else if (paragraph.nodeName === "SUP" && hideSup) {
			// <sup> is the first element of the footnote, style it as a footnote
			let supText = cleanText(paragraph.innerText) + ". ";
			content.push({
				text: supText,
				style: "footNote"
			});
		} else if (paragraph.nodeName === "SUB") {
			let subText = cleanText(paragraph.innerText) + " ";
			// if sub is the last element in it's parent
			if (paragraph.nextSibling === null) {
				subText = subText + "\n\n";
			}
			content.push({
				text: subText,
				style: "sub"
			});
		} else if (paragraph.nodeName === "STRONG" || paragraph.nodeName === "B") {
			// strong should not have children but there are multiple instances of it throughout the content
			let isRisk = false;
			if (childCount > 1) {
				for (let i = 0; i < childCount; i++) {
					let strongEl = paragraph.childNodes[i];

					if (typeof strongEl !== "undefined") {
						// risk disclosures are special cases, they are not independant components so we have to check for them
						if (typeof strongEl.classList !== "undefined") {
							if (strongEl.classList.contains("risk-disclosure")) {
								isRisk = true;
							}
						}
						content.push({
							text: styleElement(
								strongEl,
								isRisk ? "disclosure-footer-risk" : style === "disclosure" ? "blackBold" : style,
								hideSup,
								isLegacyDisclosures,
								stripAnchorTags
							),
							bold: true
						});
					}
				}
			} else {
				// if there are no children then this is just a plain text element
				let strongText = cleanText(paragraph.innerText);
				// special risk disclosure under image spacing
				if (style === "disclosure-image-risk") {
					strongText = strongText + "\n\n";
				}
				content.push({
					text: strongText,
					bold: true,
					style: style === "disclosure" ? "blackBold" : style
				});
			}
		} else if (paragraph.nodeName === "EM" || paragraph.nodeName === "I") {
			content.push({
				text: cleanText(paragraph.innerText),
				style: style,
				italics: true
			});
		} else if (paragraph.nodeName === "UL") {
			let ulLis = paragraph.querySelectorAll("li");
			let ulItems = [];

			for (let i = 0; i < ulLis.length; i++) {
				ulItems.push(styleElement(ulLis[i], style, hideSup, isLegacyDisclosures, stripAnchorTags));
			}
			content.push({
				margin: [0, 0, 0, 10],
				ul: ulItems
			});
		} else if (paragraph.nodeName === "OL") {
			let olLis = paragraph.querySelectorAll("li");
			let olItems = [];

			for (let i = 0; i < olLis.length; i++) {
				olItems.push(styleElement(olLis[i], style, hideSup, isLegacyDisclosures, stripAnchorTags));
			}
			content.push({
				margin: [0, 0, 0, 10],
				ol: olItems
			});
		}
		// all other nodes that may have multiple children
		else if (
			(paragraph.nodeName === "P" ||
				paragraph.nodeName === "DIV" ||
				paragraph.nodeName === "SPAN" ||
				paragraph.nodeName === "LI") &&
			!isLineBreak
		) {
			if (childCount > 0) {
				for (let i = 0; i < childCount; i++) {
					// footnote <li> children can be #text, <sup>, #text or
					// #text, div.rtf-container, #text
					// if SUP has a previous sibling
					if (
						style === "footNote" &&
						paragraph.childNodes[i].nodeName === "SUP" &&
						paragraph.childNodes[i].previousSibling
					) {
						// if previous sibling is text with "/n" as textContent and that sibling is child zero, hideSup
						if (
							paragraph.childNodes[i].previousSibling.nodeName === "#text" &&
							paragraph.childNodes[i].previousSibling.textContent.includes("\n")
						) {
							hideSup = true;
						}
						// otherwise SUP is not at the beginning of the footnote, don't hide it
						else {
							hideSup = false;
						}
					}
					// if SUP has no previous sibling, SUP is the first child/footnote #, hideSup
					else if (
						style === "footNote" &&
						paragraph.childNodes[i].nodeName === "SUP" &&
						paragraph.childNodes[i].previousSibling === null
					) {
						hideSup = true;
					}

					let thisEl = styleElement(
						paragraph.childNodes[i],
						style,
						hideSup,
						isLegacyDisclosures,
						stripAnchorTags
					);
					if (typeof thisEl !== "undefined") {
						if (thisEl.length > 0) {
							content.push({
								text: thisEl
							});
						}
					}
				}
			}
		}
		return content;
	}
};
